
<div
    id="site-search-panel"
    class="overview-panel v-flex"
    :key="count"
    v-resize="onResize"
>
    <div style="margin-top: 12px; margin-left: 10px">
        <table id="site-table" class="table table-hover table-bordered">
            <thead>
            <tr class="table-header">
                <th class="text-center" style="width: 30px">
                    <v-table-header-cell
                        group   ="msd.overview.header"
                        first   = "lmstate"
                        v-model = "sort"
                    />
                </th>
                <th class="text-center" style="width: 30px">
                    <v-table-header-cell
                        group   ="msd.overview.header"
                        first   = "state"
                        v-model = "sort"
                    />
                </th>

                <th class="text-center" style="width: 30px">
                    <v-table-header-cell
                        group   ="msd.overview.header"
                        first   = "sitetype"
                        v-model = "sort"
                    />
                </th>

                <th class="text-center" style="width: 100px">
                    <v-table-header-cell
                        group   ="msd.overview.header"
                        first   = "fabricNo"
                        v-model = "sort"
                    />
                </th>
                <th class="text-center">
                    <v-table-header-cell
                        group   ="msd.overview.header"
                        first   = "customer"
                        v-model = "sort"
                    />
                </th>
                <th class="text-center">
                    <v-table-header-cell
                        group   ="msd.overview.header"
                        first  ="city"
                        v-model = "sort"
                    />
                </th>
                <th class="text-center">
                    <v-table-header-cell
                        group   ="msd.overview.header"
                        first   = "street"
                        v-model = "sort"
                    />
                </th>
                <th class="text-center">
                    <v-table-header-cell
                        group   ="msd.overview.header"
                        first   = "ve"
                        v-model = "sort"
                    />
                </th>
                <th class="text-center">
                    <v-table-header-cell
                        group   ="msd.overview.header"
                        first   = "ve2"
                        v-model = "sort"
                    />
                </th>
                <th class="text-center">
                    <v-table-header-cell
                        group   ="msd.overview.header"
                        first   = "ve3"
                        v-model = "sort"
                    />
                </th>
            </tr>
            </thead>
        </table>
    </div>
</div>
